<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Informations
              </router-link>
            </li>

            

            <li>
              <router-link
                to="/settings-edit-password"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Changement de mot de passe
              </router-link>
            </li>

            <!-- <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Changement RIB
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Changement Téléphone
              </router-link>
            </li> -->

            <!-- <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Ville Retour & Ramassage
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="d-flex align-items-center gap-3">
                  <!-- User Image -->
                  <div class="image position-relative">
                    <img
                      :src="logoPreview || require('@/assets/images/NoImage.png')"
                      class="rounded-circle"
                      width="85"
                      height="85"
                      
                    />
                  </div>

                  <!-- File Input -->
                  <div class="form-group mb-0">
                    <label class="d-block text-black fw-semibold mb-10">
                      Upload Your Profile Picture
                    </label>
                    <input
                      class="form-control fs-15 text-black shadow-none"
                      type="file"
                      id="formFile"
                      @change="onFileChangeLogo"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Carte d'identité nationale
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. Adam"
                    :value="userData.cin"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. +001 321 4567"
                    v-model="userData.phone"
                  />
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse e-mail
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. adam127704@gmail.com"
                    :value="userData.email"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Magasin
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.store"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Brand
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.brand"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type d'entreprise
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.company_type"
                  />
                </div>
              </div>


              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    web site
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.website"
                  />
                </div>
              </div>
              
              

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Coupon
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.coupon"
                  />
                </div>
              </div>

                <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Banque
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.bank"
                  />
                </div>
              </div>

                <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    RIB
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.rib"
                  />
                </div>
              </div>

                <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.address"
                  />
                </div>
              </div>
                <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Ville
                  </label>
                  <input
                    type="text"
                    disabled
                    class="form-control shadow-none rounded-0 text-black"
                    :value="userData.city"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                  >
                    Enregistrer les modifications
                  </button>
                  <!-- <button
                    type="button"
                    class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                  >
                    <i
                      class="flaticon-delete lh-1 me-1 position-relative top-2"
                    ></i>
                    <span class="position-relative">Cancel</span>
                  </button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import api from "@/utils/axios";
// import Select2 from "@/components/Select2.vue";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "AccountSettings",
  //  components :{ Select2 },

  setup: () => {
    const { showToast } = useAppToast();

    const modules = {
      module: BlotFormatter,
      ImageUploader,
      options: {
        upload: (file: string | Blob) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            axios
              .post("/upload-image", formData)
              .then((res: { data: { url: unknown } }) => {
                console.log(res);
                resolve(res.data.url);
              })
              .catch((err: unknown) => {
                reject("Upload failed");
                console.error("Error:", err);
              });
          });
        },
      },
    };

    const logoPreview = ref<string | null>(null);
    const logoFile = ref<File | null>(null);
    const userData = reactive<Record<string, any>>({});
    const cities = ref<any[] | null>(null);

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/client/showAccount`);
        Object.assign(userData, response.data.data);
        if (response.data.data.image) {
          logoPreview.value = response.data.data.image;
        }
        console.log("Fetched user account:", userData); 
      } catch (error) {
        console.error("Error fetching user account:", error);
      }

      
    });

    const onFileChangeLogo = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        logoFile.value = file;
        logoPreview.value = URL.createObjectURL(file);
      }
    };

    // Submit form
    async function submitForm() {
      try {
        const formData = new FormData();
        // formData.append("name", userData.name);
        // formData.append("website", userData.website);
        // formData.append("email", userData.email);
        formData.append("phone", userData.phone);
        // formData.append("siege", userData.siege);
        // formData.append("devis", userData.currency);
        // formData.append("adresse", userData.adresse);
        // formData.append("conditions", userData.conditions);

        if (logoFile.value) {
          formData.append("pic", logoFile.value);
        }

        const response = await api.post("/api/auth/client/EditLogo", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.success) {
          showToast("Settings saved successfully!", "success");
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while saving settings.", "error");
      }
    }

    return {
      modules,
      logoPreview,
      cities,
      userData,
      onFileChangeLogo,
      submitForm,
    };
  },
});
</script>